import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import type { Rarity } from '#src/__generated__/globalTypes.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { LabelS } from '#src/atoms/typography/index.tsx';
import { OverlapItems } from '#src/atoms/ui/OverlapItems/index.tsx';
import { ScarcityAvatar } from '#src/atoms/ui/ScarcityAvatar/index.tsx';
import { unitMapping, type Unit } from '#src/lib/style.ts';

const Avatar = styled(ScarcityAvatar)`
  width: var(--size);
`;

type AvatarProps = {
  slug: string;
  name?: string;
  avatarUrl?: string | null;
  avatar?: ReactNode;
  scarcity?: Rarity;
};

type Props = {
  avatars?: AvatarProps[];
  additionalPlayersCount?: number;
  size?: Unit;
};

export const OverlappingAvatars = ({
  avatars = [],
  additionalPlayersCount,
  size = 2.5,
}: Props) => {
  const withAdditionalCount = (additionalPlayersCount || 0) > 0;

  return (
    <Horizontal
      style={{ '--size': unitMapping[size] } as CSSProperties}
      center
      gap={0.5}
    >
      <OverlapItems>
        {avatars.map(avatar => (
          <Avatar key={avatar.slug} {...avatar} />
        ))}
      </OverlapItems>
      {!!withAdditionalCount && (
        <LabelS color="var(--c-nd-500-opaque)" bold>
          +{additionalPlayersCount}
        </LabelS>
      )}
    </Horizontal>
  );
};
